/* eslint-disable */
import React, { useState, useRef } from "react";
import { Modal, Divider, Button, Box, Text } from "@mantine/core";
import ModalHeader from "components/ModalHeader";
import { useDeleteAttendanceRecord } from "api/attendance/deleteAttendanceRecord";

type DeleteAttendanceModalProps = {
  opened: boolean;
  onClose: () => void;
  recordId: string;
  employeeName?: string;
  day?: string;
};

function DeleteAttendanceModal({
  opened,
  onClose,
  recordId,
  employeeName,
  day,
}: DeleteAttendanceModalProps) {
  const { mutate: deleteRecord, isLoading } = useDeleteAttendanceRecord();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const formRef = useRef<HTMLFormElement | null>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (hasSubmitted || isLoading) return;
    setHasSubmitted(true);

    if (!recordId) {
      console.error("Record ID is missing");
      setHasSubmitted(false);
      return;
    }

    deleteRecord(recordId, {
      onSuccess: (res: any) => {
        console.log("Attendance record deleted successfully:", res);
        setHasSubmitted(false);
        onClose();
      },
      onError: (err: any) => {
        console.error("Failed to delete attendance record:", err);
        setHasSubmitted(false);
      },
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={() => {
        setHasSubmitted(false);
        onClose();
      }}
      size="md"
      withCloseButton={false}
      transitionDuration={300}
      centered
      overlayOpacity={0.5}
    >
      <ModalHeader
        title="Delete Attendance Record"
        onClose={onClose}
        ariaLabel="Close delete attendance modal"
      />
      <Divider mb="md" />

      <Box
        component="form"
        ref={formRef}
        onSubmit={handleSubmit}
        style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
      >
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Text
            size="sm"
            style={{
              fontWeight: 500,
              textAlign: "center",
              lineHeight: 1.4,
            }}
          >
            Are you sure you want to delete this attendance record
            {employeeName ? ` for ${employeeName}` : ""}
            {day ? ` on ${day}` : ""}?
          </Text>
          <Text
            size="xs"
            color="dimmed"
            mt="xs"
            style={{ textAlign: "center", lineHeight: 1.4 }}
          >
            This will permanently remove the attendance record along with all
            related punch-in/out activities and pending approvals. This action
            cannot be undone.
          </Text>
        </Box>

        <Button
          type="submit"
          fullWidth
          loading={isLoading || hasSubmitted}
          color="red"
        >
          Yes, Delete Record
        </Button>
        <Button
          variant="light"
          onClick={() => {
            setHasSubmitted(false);
            onClose();
          }}
          fullWidth
          disabled={isLoading}
        >
          No, Keep It
        </Button>
      </Box>
    </Modal>
  );
}

export default DeleteAttendanceModal;
